import { Navigate } from "react-router-dom"
import { Feature } from "lib/@components/feature"
import { FEATURE_FLAG_PROJECT_BRIDGE } from "./server/feature-flag-project-bridge.mjs"
import { ProjectBridgeDetailContent } from "./project-bridge-detail-content"

export function ProjectBridgeDetailPage() {
    return (
        <Feature feature={FEATURE_FLAG_PROJECT_BRIDGE} fallback={<Navigate to="/app" replace />}>
            <ProjectBridgeDetailContent />
        </Feature>
    )
}
